import {GetterTree} from 'vuex';
import {RootState} from '@/store';
import {DatapointsState} from "@/store/modules/datapoints/index";
import {DataPointsResponse} from "@/models/response/BrainpowerApiResponse";

export const getters: GetterTree<DatapointsState, RootState> = {

    datapoints(state): DataPointsResponse {
        return state.datapoints
    }
}
